module.exports = __webpack_public_path__ + "static/media/review-image-sofiak.1bb177ea.png";